(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-offre-kit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-hb-offre-input]') : null;
    if (!input) return;
    const root = input.closest('[data-hb-offre]');
    const button = root && root.querySelector('[data-hb-add]');
    if (!button) return;
    button.setAttribute('data-variant-id', input.value);
    const total = root.querySelector('[data-hb-offre-total]');
    if (total) total.textContent = input.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
